<template>
  <div class="tabs-panel-component" v-show="show">
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
.tabs-panel-component {
}
</style>

<script>
export default {
  name: "TabsPanelComponent",
  props: {
    title: {
      type: String,
    },
    icon: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {},
};
</script>
